module.exports = __webpack_public_path__ + "img/visual-05.65b11281.png";